var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6A6A6A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0h8.75c.69 0 1.25.56 1.25 1.25v5c0 .69-.56 1.25-1.25 1.25h-6.25L7.5 10V1.25C7.5.56 8.06 0 8.75 0z",
    transform: "translate(-55 -622) translate(55 622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.75v7.5H2.5V5h3.75V1.25H2.5C1.12 1.25 0 2.37 0 3.75V17.5C0 18.88 1.12 20 2.5 20h8.75c1.38 0 2.5-1.12 2.5-2.5V8.75h-2.5z",
    transform: "translate(-55 -622) translate(55 622)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileChat);
export default __webpack_public_path__ + "static/media/mobile_chat.476d6dc84de7c84af9a141bdf22923f9.svg";
export { ForwardRef as ReactComponent };